import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCustomersWithFilters, fetchLabels } from './store/slice';
import CustomerTopHead from './customermasters-top-head';
import CustomerContent from './customermasters-content';
import CustomerModals from './customermasters-modals';
import { actions as customersAction } from './store/slice';

const { resetFilters } = customersAction;

const CustomerView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchCustomersWithFilters());
    dispatch(fetchLabels());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Customer</h4>
              </div>
            </div>
            <CustomerTopHead />
          </div>
          <CustomerContent />
          <CustomerModals />
        </div>
      </div>
    </div>
  );
};

export default CustomerView;
